// TEMP dev-only preview to eyeball SuiDashboardPage with mock data.
import { SuiDashboardPage } from "@/pages/SuiDashboard";
import { AppChrome } from "@/components/Chrome";
import type { AgentObject } from "@/lib/api";

const now = Date.now();
const inDays = (d: number) => new Date(now + d * 86_400_000).toISOString();
const agoMin = (m: number) => new Date(now - m * 60_000).toISOString();

const mock: AgentObject[] = [
  {
    id: "agt_orca",
    name: "orca-trader-2",
    chain: "sui",
    framework: "sak",
    status: "active",
    created_at: agoMin(8),
    sui_vault_id: "0x9a7c3f2e1b8d4c5a6f0e9d8c7b6a5f4e3d2c1b0a9f8e7d6c5b4a3f2e1d0c9b8a",
    sui_policy_id: "0x3f6e2d1c0b9a8f7e6d5c4b3a2f1e0d9c8b7a6f5e4d3c2b1a0f9e8d7c6b5a4f3e",
    sui_agent_cap_id: "0x1c0e9d8c7b6a5f4e3d2c1b0a9f8e7d6c5b4a3f2e1d0c9b8a7c3f2e1b8d4c5a6f",
    policy: {
      per_asset_caps: [{ asset: "SUI", per_tx: 2, per_day: 10, spent_today: 6.4 }],
      allowed_actions: ["deepbook_swap", "deepbook_limit"],
      expires_at: inDays(21),
    },
  },
  {
    id: "agt_market",
    name: "deepbook-mm",
    chain: "sui",
    framework: "custom",
    status: "active",
    created_at: agoMin(140),
    sui_vault_id: "0x44aa11bb22cc33dd44ee55ff66aa77bb88cc99dd00ee11ff22aa33bb44cc55dd",
    sui_policy_id: "0x55bb22cc33dd44ee55ff66aa77bb88cc99dd00ee11ff22aa33bb44cc55dd66ee",
    sui_agent_cap_id: "0x66cc33dd44ee55ff66aa77bb88cc99dd00ee11ff22aa33bb44cc55dd66ee77ff",
    policy: {
      per_asset_caps: [{ asset: "SUI", per_tx: 5, per_day: 40, spent_today: 38.2 }],
      allowed_actions: ["deepbook_swap", "deepbook_limit", "deepbook_cancel"],
      expires_at: inDays(6),
    },
  },
  {
    id: "agt_yield",
    name: "navi-yield-bot",
    chain: "sui",
    framework: "eliza",
    status: "paused",
    created_at: agoMin(900),
    sui_vault_id: "0x77dd44ee55ff66aa77bb88cc99dd00ee11ff22aa33bb44cc55dd66ee77ff88aa",
    sui_policy_id: "0x88ee55ff66aa77bb88cc99dd00ee11ff22aa33bb44cc55dd66ee77ff88aa99bb",
    sui_agent_cap_id: "0x99ff66aa77bb88cc99dd00ee11ff22aa33bb44cc55dd66ee77ff88aa99bb00cc",
    policy: {
      per_asset_caps: [{ asset: "SUI", per_tx: 3, per_day: 15, spent_today: 0 }],
      allowed_actions: ["navi_deposit", "navi_withdraw"],
      expires_at: inDays(45),
    },
  },
  {
    id: "agt_router",
    name: "cetus-router",
    chain: "sui",
    framework: "mcp",
    status: "active",
    created_at: agoMin(30),
    sui_vault_id: "0xaa00bb11cc22dd33ee44ff55aa66bb77cc88dd99ee00ff11aa22bb33cc44dd55",
    sui_policy_id: "0xbb11cc22dd33ee44ff55aa66bb77cc88dd99ee00ff11aa22bb33cc44dd55ee66",
    sui_agent_cap_id: "0xcc22dd33ee44ff55aa66bb77cc88dd99ee00ff11aa22bb33cc44dd55ee66ff77",
    policy: {
      per_asset_caps: [{ asset: "SUI", per_tx: 1, per_day: 8, spent_today: 1.1 }],
      allowed_actions: ["cetus_swap"],
      expires_at: inDays(2),
    },
  },
  {
    id: "agt_rogue",
    name: "scallop-lev-1",
    chain: "sui",
    framework: "virtuals",
    status: "revoked",
    created_at: agoMin(2880),
    revoked_at: agoMin(55),
    revoked_reason: "cap breach attempt",
    sui_vault_id: "0xdd33ee44ff55aa66bb77cc88dd99ee00ff11aa22bb33cc44dd55ee66ff77aa88",
    sui_policy_id: "0xee44ff55aa66bb77cc88dd99ee00ff11aa22bb33cc44dd55ee66ff77aa88bb99",
    sui_agent_cap_id: "0xff55aa66bb77cc88dd99ee00ff11aa22bb33cc44dd55ee66ff77aa88bb99cc00",
    policy: {
      per_asset_caps: [{ asset: "SUI", per_tx: 10, per_day: 100, spent_today: 0 }],
      allowed_actions: ["scallop_borrow", "scallop_repay"],
      expires_at: inDays(-1),
    },
  },
] as unknown as AgentObject[];

export function PreviewDashPage() {
  return (
    <AppChrome>
      <SuiDashboardPage agents={mock} />
    </AppChrome>
  );
}
